const FORM_KEY_PREFIX_INDEX: string = 'index';

export default FORM_KEY_PREFIX_INDEX;
